import { render, staticRenderFns } from "./GenericEpisodeList.vue?vue&type=template&id=5dd89c5e&scoped=true"
import script from "./GenericEpisodeList.vue?vue&type=script&lang=js"
export * from "./GenericEpisodeList.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/season_detail.css?vue&type=style&index=0&id=5dd89c5e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd89c5e",
  null
  
)

export default component.exports